import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";
import { handleRecentSearchTermClick } from "search/actions";
import { useSearchStore } from "search/store";
import {
  addSearchKeywordToLocalStorage,
  getRecentSearchKeywordsFromLocalStorage,
} from "search/utils";

const Wrapper = styled.div`
  height: 100%;
  width: 75%;
`;

const NoSearchKeywordText = styled.div`
  color: ${colors.gray6};
`;

const PreviousSearchHeader = styled.div`
  color: ${colors.gray1};
  font-size: 0.857rem;
  margin-bottom: 0.714rem;
`;

const PreviousSearchListItem = styled.div`
  color: ${colors.gray1};
  font-size: 1.143rem;
  line-height: 1.875;
  white-space: nowrap;
  width: min-content;

  &:hover {
    color: ${colors.blue7};
    cursor: pointer;
  }
`;

export const RecentSearchKeywords = () => {
  const { dispatch } = useSearchStore();

  const recentSearchKeywords = getRecentSearchKeywordsFromLocalStorage();

  if (recentSearchKeywords.length === 0) {
    return (
      <Wrapper>
        <NoSearchKeywordText>
          No previously searched keywords
        </NoSearchKeywordText>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <PreviousSearchHeader>Previous searches</PreviousSearchHeader>
      {recentSearchKeywords.map((keyword: string) => {
        return (
          <PreviousSearchListItem
            key={keyword}
            onClick={() => {
              addSearchKeywordToLocalStorage(keyword);
              dispatch(handleRecentSearchTermClick(keyword));
            }}
          >
            {keyword}
          </PreviousSearchListItem>
        );
      })}
    </Wrapper>
  );
};
